export const studyTypeData = {
  in_person: 'Prezenční',
  online: 'Online',
  hybrid: 'Kombinované',
};

export const supportTypeData = {
  financial: 'Finanční',
  material: 'Materiální',
  organizational: 'Organizační',
};

export enum AutoEvaluationStateEnum {
  COMPLETED = 'completed',
  NOT_COMPLETED = 'not_completed',
}

export const autoEvaluationStateData = {
  completed: 'Splněno',
  not_completed: 'Nesplněno',
};
